(() => {
  if (customElements.get('joffz-product-sticky')) return;
  customElements.define('joffz-product-sticky', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.closest('quick-add-modal, quick-view-modal')) return;
      this.scope = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.nativeButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      if (!this.scope || !this.form || !this.nativeButton) return;
      this.ready = true;
      this.button = this.querySelector('[data-sticky-add]');
      this.label = this.querySelector('[data-sticky-label]');
      this.price = this.querySelector('[data-sticky-price]');
      this.variant = this.querySelector('[data-sticky-variant]');
      this.options = this.querySelector('[data-sticky-options]');
      this.nativePrice = document.getElementById(`price-${this.dataset.section}`);
      this.sync = this.sync.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onVariant = event => {
        if (event.detail?.sectionId !== this.dataset.section) return;
        this.sync();
      };
      this.onError = event => {
        if (event.detail?.source !== this.dataset.section) return;
        this.nativeButton.scrollIntoView({block: 'center', behavior: 'smooth'});
        this.nativeButton.focus({preventScroll: true});
      };
      this.onFocus = () => {
        if (document.activeElement === this.button && this.hidden) this.nativeButton.focus({preventScroll: true});
      };
      this.visibilityFrame = 0;
      this.scheduleVisibility = () => {
        if (this.visibilityFrame) return;
        this.visibilityFrame = requestAnimationFrame(() => {
          this.visibilityFrame = 0;
          this.syncVisibility();
        });
      };
      this.addEventListener('click', this.onClick);
      this.scope.addEventListener('change', this.sync);
      document.addEventListener('variant:change', this.onVariant);
      document.addEventListener('cart:error', this.onError);
      window.addEventListener('scroll', this.scheduleVisibility, {passive: true});
      window.addEventListener('resize', this.scheduleVisibility, {passive: true});
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.nativeButton, {attributes: true, childList: true, subtree: true, characterData: true});
      if (this.nativePrice) this.observer.observe(this.nativePrice, {attributes: true, childList: true, subtree: true, characterData: true});
      this.intersection = new IntersectionObserver(() => this.syncVisibility(), {threshold: 0});
      this.intersection.observe(this.nativeButton);
      this.sync();
      this.syncVisibility();
    }
    syncVisibility() {
      if (!this.ready) return;
      const hidden = this.nativeButton.getBoundingClientRect().bottom > 0;
      if (hidden === this.hidden) return;
      this.hidden = hidden;
      this.onFocus();
    }
    sync() {
      const busy = this.nativeButton.classList.contains('loading');
      this.button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.setAttribute('aria-busy', String(busy));
      const label = this.nativeButton.querySelector('span:not(.hidden)')?.textContent.trim() || this.dataset.addLabel;
      if (this.label.textContent !== label) this.label.textContent = label;
      const priceContainer = this.nativePrice?.querySelector('.price');
      const priceSource = priceContainer?.querySelector(priceContainer.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      const price = priceSource?.textContent.trim();
      if (price && this.price.textContent !== price) this.price.textContent = price;
      const choices = [...this.scope.querySelectorAll('variant-selects fieldset, variant-radios fieldset')].map(fieldset => fieldset.querySelector('select')?.value || fieldset.querySelector('input:checked')?.value).filter(Boolean).join(' / ');
      if (this.variant.textContent !== choices) this.variant.textContent = choices;
      this.options.hidden = !choices;
    }
    onClick(event) {
      if (event.target.closest('[data-sticky-options]')) {
        const picker = this.scope.querySelector('variant-selects, variant-radios');
        if (!picker) return;
        picker.scrollIntoView({block: 'center', behavior: 'smooth'});
        picker.querySelector('button[aria-checked=true], select, input:checked')?.focus({preventScroll: true});
      }
      if (!event.target.closest('[data-sticky-add]')) return;
      if (this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true') return;
      this.nativeButton.click();
      this.sync();
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener('change', this.sync);
      document.removeEventListener('variant:change', this.onVariant);
      document.removeEventListener('cart:error', this.onError);
      window.removeEventListener('scroll', this.scheduleVisibility);
      window.removeEventListener('resize', this.scheduleVisibility);
      cancelAnimationFrame(this.visibilityFrame);
      this.visibilityFrame = 0;
      this.ready = false;
    }
  });
})();
